import React from "react";

export default function CustomPagination({
                                             postsPerPage,
                                             totalPosts,
                                             paginateFront,
                                             paginateBack,
                                             currentPage,
                                             totalUsers,
                                             current
                                         }) {


    return (
        <div className='pt-5'>
            <div>
                <p className='text-sm text-gray-700'>
                    Mostrando del
                    <span className='font-medium px-1'>{current}</span>
                    hasta el
                    <span className='font-medium px-1'> {currentPage * postsPerPage} </span>
                    de
                    <span className='font-medium px-1'> {totalUsers} </span>
                    resultados
                </p>
            </div>
            <nav className='block'></nav>
            <div className="pt-3">
                <nav
                    className='relative z-0 inline-flex rounded-md shadow-sm -space-x-px'
                    aria-label='Pagination'
                >
                    <a
                        onClick={() => {
                            if (currentPage > 1) {
                                paginateBack();
                            }
                        }}
                        href='#'
                        className='relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50'
                    >
                        <span>Anterior</span>
                    </a>

                    <a
                        onClick={() => {
                            if (currentPage < totalPosts) {
                                paginateFront();
                            }
                        }}
                        href='#'
                        className='relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50'
                    >
                        <span>Siguiente</span>
                    </a>
                </nav>
            </div>
        </div>
    );
}